export const Device = {
  App: 'App',
  AppPort: 'AppPort',
  AppLand: 'AppLand',
  WebPort: 'WebPort',
  WebLand: 'WebLand',
  Tablet: 'Tablet',
  Large: 'Large',
};
